import script from "./AdminPromotions.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPromotions.vue?vue&type=script&setup=true&lang=js"

import "./AdminPromotions.vue?vue&type=style&index=0&id=de6c30ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de6c30ca"]])

export default __exports__